<template>
    <div>
        <div class="col-xs-3" style="height: 100%; padding:0" v-show="!loading">
            <dashboard-item-menu
                :titleColor="mainTitleColor"
                :titleBackgroundColor="mainTitleBackgroundColor"
                :title="mainTitle"
                :menuList="locationProgressData"
                @menuItemClicked="onCountryClicked"></dashboard-item-menu>
        </div>
        <div class="col-xs-9" style="height: 100%; overflow: hidden" v-show="!loading">
            <div style="width:110%; height:80%; position: relative; top: -20px; left: -10px">
                <comb-world-map ref="feedMap" :feed="feed"></comb-world-map>
            </div>
            <div style="width: 100%; height: 25%; position: relative; top:-40px;">
                <live-feed-table :feed="liveFeedTableData"></live-feed-table>
            </div>
        </div>
        <div class="enlarge-button grow" @click="onEnlargeClick" v-show="!loading">
            <img src="../../../assets/enlarge-button.svg" class="enlarge-button-icon"/>
        </div>
        <loading-modal v-if="loading" :color="'red'"></loading-modal>
    </div>
</template>

<script>

    import DashboardItemMenu from '@/components/menu/DashboardItemMenu.vue'
    import LiveFeedTable from '@/components/live-feed-table/LiveFeedTable.vue'
    import CombWorldMap from '@/components/world-map/CombWorldMap'
    import Common from '@/utils/Common.vue'
    import Constants from '@/utils/constants'
    import countries from '@/assets/countries.json'
    import LoadingModal from "@/components/modals/LoadingModal";

    import {mapActions} from 'vuex';
    import {mapGetters} from 'vuex';


    const PROGRESS_COLOR = "rgb(191,0,51)";
    const MENU_MAIN_TITLE_COLOR = "black";
    const MENU_MAIN_TITLE_BACKGROUND_COLOR = "rgb(255,0,66)";
    const MENU_ITEM_BACKGROUND_COLOR = "rgb(191,0,51)";
    const MENU_ITEM_TEXT_COLOR = "white";
    const MENU_TITLE_COLOR = "white";

    export default {
        name: "realtime-malware-detection",
        props: {
            itemNumber: {
                type: Number,
                required: true
            }
        },
        components: {
            DashboardItemMenu: DashboardItemMenu,
            LiveFeedTable: LiveFeedTable,
            CombWorldMap: CombWorldMap,
            LoadingModal: LoadingModal
        },
        mixins: [Common],
        data() {
            return {
                mainTitle: 'REALTIME\nMALWARE\nDETECTION',
                mainTitleColor: MENU_MAIN_TITLE_COLOR,
                mainTitleBackgroundColor: MENU_MAIN_TITLE_BACKGROUND_COLOR,
                realtimeMalwareDetectionMenuList: [],
                feed: [],
                locationStats: {},
                locationProgressData: [],
                liveFeedTableData: [],
                interval: null,
                loading: false,
                isFirstRequest: true,
                newFeedDisplayInterval: 0,
                requestCount: 0,
                pageName: 'Realtime Malware Detection Widget',
                date_format: 'MM/DD/YYYY, HH:mm:ss Z'
            }
        },
        methods: {
            onCountryClicked(menuItem) {
                let log_start = Date.now();
                this.saveLog(this, this.pageName, this.pageName + ' country clicked. Country name: (' + menuItem.text + ')', this.getDurationInSeconds(log_start, Date.now()), null);
            },
            createRealtimeMalwareDetectionMenuItem(text, progress) {
                return {
                    text: text,
                    color: MENU_ITEM_TEXT_COLOR,
                    progress: progress,
                    progressColor: PROGRESS_COLOR
                };
            },
            createRealtimeMalwareDetectionMenuList(items) {
                return [
                    {
                        type: "selectableProgress",
                        text: "GLOBAL",
                        color: MENU_TITLE_COLOR,
                        backgroundColor: MENU_ITEM_BACKGROUND_COLOR,
                        open: true,
                        items: items
                    }
                ];
            },
            fetchNewFeedData() {
                let log_start = null;
                var path = Constants.BACKEND_URL + '/threat/flow/all-malware-files/' + this.requestCount;
                var params = {};
                if (this.latestTimestamp)
                    params.latestTimestamp = this.latestTimestamp;

                if (this.isFirstRequest) {
                    this.loading = true;
                    log_start = Date.now();
                }

                this.$http.get(path, {params: params})
                    .then(response => {
                        this.feed = this.feed.concat(response.body.malwareData);
                        if (this.feed && this.feed.length > 0)
                            this.latestTimestamp = this.feed[this.feed.length - 1].timestamp;
                        this.loading = false;
                        if (this.isFirstRequest) {
                            this.$emit('loaded', 'realtime-malware-detection', this.getDurationInSeconds(log_start, Date.now()));
                        }
                        this.isFirstRequest = false;
                        this.newFeedDisplayInterval = Math.ceil(500 / (this.feed.length / 300));
                        this.requestCount = response.body.nextRequestCount;
                    }, response => {
                        this.loading = false;
                        if (this.isFirstRequest) {
                            this.$emit('loaded', 'realtime-malware-detection', this.getDurationInSeconds(log_start, Date.now()));
                        }
                        this.isFirstRequest = false;
                    });
            },
            periodicallyFetchNewFeedData() {
                var self = this;
                this.fetchNewFeedData();
                this.interval = setInterval(() => {
                    self.fetchNewFeedData();
                }, 1000 * 60);
            },
            addLocationStat(newFeedData) {
                if (!newFeedData) return;

                var countryStat = this.locationStats[newFeedData.geoPoint.country_code];
                if (countryStat)
                    countryStat++;
                else
                    countryStat = 1;

                this.locationStats[newFeedData.geoPoint.country_code] = countryStat;
            },
            removeLocationStat(oldFeedData) {
                if (!oldFeedData) return;
                var countryStat = this.locationStats[oldFeedData.country_code];
                if (countryStat) {
                    countryStat--;
                    if (countryStat == 0)
                        delete this.locationStats[oldFeedData.country_code];
                    else
                        this.locationStats[oldFeedData.country_code] = countryStat;
                }
            },
            periodicallyDisplayNewFeedData() {
                var self = this;

                function getRandomMilisecond() {
                    var number = self.getRandomInRange(0, 20, 0);
                    if (number % 2 == 0) {
                        return number;
                    }
                    else {
                        return -1 * number;
                    }
                }

                function intervalFunction() {
                    // Retrieve a new log from backlog
                    let newFeedData = self.feed.shift();

                    if (newFeedData) {
                        self.$refs.feedMap.showPoint(newFeedData);
                        self.addLocationStat(newFeedData);
                        self.updateLocationProgress();
                        self.updateLiveFeedTable(newFeedData);
                    }

                    clearInterval(self.displayNewFeedDataInterval);
                    self.displayNewFeedDataInterval = setInterval(intervalFunction, self.newFeedDisplayInterval + getRandomMilisecond());
                }

                this.displayNewFeedDataInterval = setInterval(intervalFunction, this.newFeedDisplayInterval + getRandomMilisecond());
            },
            getCountryName(countryCode) {
                if (countries.hasOwnProperty(countryCode.toUpperCase())) {
                    return countries[countryCode.toUpperCase()];
                }
                else {
                    return countryCode;
                }
            },
            updateLocationProgress() {
                var total = 0;
                var newLocationTableData = [];
                // Get total number of records
                for (let countryCode in this.locationStats) {
                    total += this.locationStats[countryCode];
                }
                // Create location table data
                for (let countryCode in this.locationStats) {
                    let count = this.locationStats[countryCode];
                    let percentage = Math.ceil((100 * count / total));
                    let countryName = this.getCountryName(countryCode);

                    newLocationTableData.push(this.createRealtimeMalwareDetectionMenuItem(countryName, percentage));
                }

                // Sort the data
                this.sortyByKey("progress", newLocationTableData)
                this.locationProgressData = this.createRealtimeMalwareDetectionMenuList(newLocationTableData);
            },
            updateLiveFeedTable(newFeedData) {
                var self = this;
                this.liveFeedTableData = this.liveFeedTableData.reverse();

                this.liveFeedTableData.push({
                    hash: newFeedData.hash.toLowerCase(),
                    date: self.utcStringToLocalDate(newFeedData.timestamp, self.date_format),
                    malwareType: getTypeName(),
                    ip: newFeedData.geoPoint.ipAddress,
                    country: self.getCountryName(newFeedData.geoPoint.country_code)
                });

                if (this.liveFeedTableData.length > 5)
                    this.liveFeedTableData.shift();

                this.liveFeedTableData = this.liveFeedTableData.reverse();

                function getTypeName() {
                    var malwareFamily = newFeedData.malwareFamily;
                    var malwareType = newFeedData.malwareType;
                    var malwareSubType = newFeedData.malwareSubType;
                    if (malwareSubType && malwareSubType != '')
                        return malwareSubType;
                    else if (malwareType && malwareType != '')
                        return malwareType;
                    return malwareFamily;
                }
            },
            onEnlargeClick() {
                let log_start = Date.now();
                let enLargeClicked = this.getDashboardEnlargedItem;
                if (enLargeClicked != null) {
                    this.saveLog(this, this.pageName, this.pageName + ' minimized.', this.getDurationInSeconds(log_start, Date.now()), null);
                }
                else {
                    this.saveLog(this, this.pageName, this.pageName + ' maximized.', this.getDurationInSeconds(log_start, Date.now()), null);
                }
                this.setDashboardEnlargedItem(this.itemNumber);
            },
            ...mapActions([
                "setDashboardEnlargedItem"
            ])
        },
        computed: {
            ...mapGetters([
                "getDashboardEnlargedItem"
            ])
        },
        mounted() {
            this.periodicallyFetchNewFeedData();
            this.periodicallyDisplayNewFeedData();
        },
        beforeDestroy() {
            clearInterval(this.interval);
            clearInterval(this.displayNewFeedDataInterval);
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/dashboard-page/realtime-malware-detection/RealtimeMalwareDetection.vue